<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import { computed, watch } from 'vue'
import policyTradutor from 'tradutors/policy'
import { localeStore } from '../../stores/locale'
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'
import router from '../../router'

const storeLocale = localeStore()
const route = useRoute()
const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return policyTradutor.portugues
    } else {
      return policyTradutor.ingles
    }
})

useHead({
    templateParams: {
    subTitle: null, 
        subPage: translate.value.policyCancellationTitle,
        page_url: window.location.origin + route.fullPath,
        page_description:
        reactiveLocale.value == 'pt-br'
            ? `Bella da Semana Sedução, entretenimento, ensaios, fotos e vídeos das mais TOPs e belas modelos brasileiras na maior revista masculina do Brasil`
            : `BellaClub Seduction, entertainment, rehearsals, photos and videos of the most TOPs and beautiful Brazilian models in the largest men\'s magazine in Brazil`,
        page_image: '/favicon.ico',
        page_keywords:
        'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: reactiveLocale.value,
        page_url_pt: 'https://belladasemana.com.br/pt-br/politica-de-cancelamento',
        page_url_en: 'https://belladasemana.com.br/en/politica-de-cancelamento',
        page_canonical: 'https://belladasemana.com.br' + route.fullPath
    }
})
</script>
<template>
    <MainLayout>
        <div class="slot-body">
            <div class="container">
                <div class="column pt-5">
                <div class="col-12">
                    <span class="title" v-html="translate.policyCancellationTitle"></span>
                </div>
                <div class="col-12">
                    <span class="subtitle" v-html="translate.policyCancellationText"></span>
                </div>
                </div>
            </div>
        </div>
    </MainLayout>
</template>
<style scoped lang="css">
    .slot-body {
        margin-top: 65px !important;        
        background-color: #fff !important;
    }
    .title {
        color: #000000;        
        font-family: 'Bebas-Neue-Light';
        font-size: 64px;
        font-weight: 300;
        letter-spacing: 0;
    }
    .subtitle {
        color: #999999;
        font-family: 'Roboto-Regular';
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 0;
    }
    @media screen and (max-width: 769px) {
        .title {
            font-size: 40px;
        }
    }
</style>